import { Utility } from "./utility";

export class ListItems {
    itemname: string;
    rank: number;
    show: boolean;
    count: number;

    public constructor(itemname: string, rank: number) {
        this.itemname = itemname;
        this.rank = rank;
        this.show = true;
        this.count = 0;
    }

    public showItem(): boolean
    {
        return this.count > 0 && this.show;
    }
}

export class ListWidgetService {

    public widgets: ListItems[];

    public save(widgets) {
        this.widgets = widgets;
    }

    constructor() {
        this.widgets = [
            new ListItems("Construction Bottlenecks", 1),
            new ListItems("Bottlenecks",2),
            new ListItems("Crash Events",3),
            new ListItems("Incidents by Type",4),
            new ListItems("Work Zones",5),
            new ListItems("Road Conditions",6),
            new ListItems("Winter Closures",7),
            new ListItems("Flooding",8),
            new ListItems("Inspections by Type",9),
            new ListItems("Wait Times",10)
        ];

        let showParameter = Utility.getQueryVariable("show");
        if (showParameter) {
            // split the options.
            let showOptions = showParameter.trim().split(/\s*,\s*/);

            // hide all widgets and set default rank greater than the given number of widgets.
            for (var widget of this.widgets) {
                widget.show = false;
                widget.rank = showOptions.length + 1;
            }

            // show specified widget in the given order.
            for (var i = 0; i < showOptions.length; i++) {
                switch (showOptions[i]) {
                    case "b": {
                        this.UpdateWidget("Bottlenecks", i + 1, true);
                        break;
                    }
                    case "c": {
                        this.UpdateWidget("Crash Events", i + 1, true);
                        break;
                    }
                    case "i": {
                        this.UpdateWidget("Incidents by Type", i + 1, true);
                        break;
                    }
                    case "r": {
                        this.UpdateWidget("Road Conditions", i + 1, true);
                        break;
                    }
                    case "cb": {
                        this.UpdateWidget("Construction Bottlenecks", i + 1, true);
                        break;
                    }
                    case "w": {
                        this.UpdateWidget("Work Zones", i + 1, true);
                        break;
                    }
                    case "wc": {
                        this.UpdateWidget("Winter Closures", i + 1, true);
                        break;
                    }
                    case "f": {
                        this.UpdateWidget("Flooding", i + 1, true);
                        break;
                    }
                    case "it": {
                        this.UpdateWidget("Inspections by Type", i + 1, true);
                        break;
                    }
                    case "wt": {
                        this.UpdateWidget("Wait Times", i + 1, true);
                        break;
                    }
                    default: {
                        console.warn("Invalid show parameter", showOptions[i], ListWidgetService.name);
                    }
                }
            }

            this.widgets = this.widgets.sort((a, b) => a.rank - b.rank);
        }
    }

    public updatecount(item, count) {
        let widget = this.widgets.filter(function(x) {
            return x.itemname === item;
        })[0];
        widget.count = count;
    }

    public getdata(): ListItems[] {
        return this.widgets;
    }

    private UpdateWidget(itemname: string, rank: number, show: boolean) {
        let widget = this.widgets.filter(w => w.itemname == itemname)[0];
        widget.rank = rank;
        widget.show = show;
    }
}



// WEBPACK FOOTER //
// ./src/app/service.listwidgets.ts